import { getAccount, updateUser } from "../utils/sessionHelper";
import { firebaseClient } from "../firebaseClient";
import toast from "react-hot-toast";
import * as analytics from "utils/analytics";


export async function getCampaigns (session) {

    try {
        const key = getAccount(session)?.keyLemlist;
    
        let response = await fetch("https://us-central1-ez4cast.cloudfunctions.net/lemlistBridge-getCampaigns?key=" + key);
        let json = await response.json();
        console.log('json:', json);
    
        let campaigns = json?.campaigns ?? [];
        
        return campaigns;
    }
    catch (e) {
        console.log('error:', e)
        return [];
    }
}

export async function sendLeads (session, idCampaign, leads, isDeduplicated=true) {

    try {

        const key = getAccount(session)?.keyLemlist;
    
        

        const leadsFormatted = leads.map(lead => {
            return {
                firstName: lead.firstName ?? '',
                lastName: lead.lastName ?? '',
                connections: lead.connectionsCount,
                followers: lead.followersCount,
                id: lead.id ?? '',
                icebreaker: lead.icebreaker ?? '',
                companyName: lead.zFull?.position_groups?.[0]?.company?.name ?? '',
                jobTitle: lead.zFull?.position_groups?.[0]?.profile_positions?.[0]?.title ?? '',
                linkedinUrl: lead.profileUrl ?? '',
                summary: lead.summary ?? '',
                username: lead.username ?? '',
                // email: lead.emails?.[0] ?? lead.id + "@fake-linkedin.com",
                email: lead.emails?.[0] ?? "",
                occupation: lead.occupation ?? '',
                picture: lead.image ?? '',
            }
        });
        // }).filter(lead => lead.email);

        let dataToSend = {
            idCampaign,
            leads: leadsFormatted,
            isDeduplicated,
        }
    
        let response = await fetch("https://us-central1-ez4cast.cloudfunctions.net/lemlistBridge-pushLeads?key=" + key, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        });

        let json = await response.json();
        console.log('json:', json);

        if (json?.success) 
            toast.success('Leads sent to lemlist');
        else 
            toast.error(json?.error ?? 'Error sending leads to lemlist');
    
    }
    catch (e) {
        console.log('error:', e)
    }
    

    return;
}
